* {
  box-sizing: border-box;
}

:host {
  position: absolute;
  top: 80px;
  display: block;
  width: 100%;
  height: 96px;
  background-color: var(--cwc-color-white, #fff);
  padding: 18px 32px;
  font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
  filter: drop-shadow(0 5px 10px rgba(0,0,0,0.15));
}

:host(.hidden) {
  display: none;
}

form {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
}

input {
  flex-grow: 1;
  border: 0;
  outline: 0;
  font-size: 18px;
  line-height: 60px;
}

.search-close {
  display: grid;
  place-items: center;
  width: 28px;
  height: 38px;
  margin-left: auto;
  margin-right: 0;
  cursor: pointer;
}

.search-close svg {
  pointer-events: none;
}

@media (min-width: 1025px) {
  :host {
    top: 110px;
    padding-left: 48px;
    padding-right: 48px;
  }
}

@media (min-width: 1366px) {
  :host {
    padding-left: 64px;
    padding-right: 64px;
  }
}

@media (min-width: 1680px) {
  :host {
    padding-left: 96px;
    padding-right: 96px;
  }
}
